module.exports = __webpack_public_path__ + "static/media/logo_new.b0a59c16.png";